module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Dollar-286f050ee72be4b0d9a254c4eacbe244.svg";